export default function eq(first: any, second: any) {
  return first == second;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    eq: typeof eq;
  }
}
